import * as React from 'react'
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material'

// Define the shape of the field options for the dropdown
interface SearchField {
  value: string
  label: string
}

interface SearchBarProps {
  onSearch: (filteredData: any[]) => void
  fields: SearchField[]
  originalData: any[]
}

export default function SearchBar({
  onSearch,
  fields,
  originalData,
}: SearchBarProps) {
  const [searchQuery, setSearchQuery] = React.useState('')
  const [searchField, setSearchField] = React.useState(fields[0]?.value || '')

  React.useEffect(() => {
    // Ensure a search field is selected if available
    if (fields.length > 0 && !searchField) {
      setSearchField(fields[0].value)
    }

    if (!searchQuery.trim()) {
      onSearch(originalData)
      return
    }

    const filtered = originalData.filter((item) => {
      const itemValue = item[searchField]

      if (itemValue === null || itemValue === undefined) {
        return false
      }

      if (typeof itemValue === 'string') {
        return itemValue.toLowerCase().includes(searchQuery.toLowerCase())
      }
      if (typeof itemValue === 'number') {
        return itemValue
          .toString()
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      }
      if (typeof itemValue === 'boolean') {
        return (
          (searchQuery.toLowerCase() === 'true' && itemValue) ||
          (searchQuery.toLowerCase() === 'false' && !itemValue)
        )
      }

      return false
    })

    onSearch(filtered)
  }, [searchQuery, searchField, originalData, onSearch, fields])

  const handleFieldChange = (event: any) => {
    setSearchField(event.target.value)
  }

  const handleQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 3,
        alignItems: 'center',
        gap: 2,
      }}
    >
      <FormControl sx={{ minWidth: 180 }}>
        <InputLabel id="search-field-label">Rechercher dans</InputLabel>
        <Select
          labelId="search-field-label"
          value={searchField}
          label="Rechercher dans"
          onChange={handleFieldChange}
          size="small"
        >
          {fields.map((field) => (
            <MenuItem key={field.value} value={field.value}>
              {field.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        fullWidth
        variant="outlined"
        label={`Entrez votre recherche...`}
        value={searchQuery}
        onChange={handleQueryChange}
        size="small"
      />
    </Box>
  )
}
